/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// type 0 总榜 1 日榜 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92450317
export const getRank = createAsyncThunk(
  'ShowYourLove/getRank',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/cp_rank', {
      ...store.getState().env.deviceinfo,
      ...p,
      limit: 50,
    })
    return resp.data
  }
)
// http://wiki.xunlei.cn/pages/viewpage.action?pageId=92450326
export const cp_home = createAsyncThunk(
  'ShowYourLove/cp_home',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/cp_home', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const cp_day_receive = createAsyncThunk(
  'ShowYourLove/cp_day_receive',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/cp_day_receive', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const cp_receive = createAsyncThunk(
  'ShowYourLove/cp_receive',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/cp_receive', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 获取邀请落地状态 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92450379
export const cp_invitation_home = createAsyncThunk(
  'ShowYourLove/cp_invitation_home',
  async (
    p: {inviter: number; invitee: number; position: number},
    store: any
  ) => {
    const resp = await http.post('/live/activity/cp_invitation_home', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export enum MANNER_TYPE {
  refuse = 0,
  accept = 1,
}
// 受邀人处理邀请
export const cp_invitation_handle = createAsyncThunk(
  'ShowYourLove/cp_invitation_handle',
  async (
    p: {
      inviter: number
      invitee: number
      position: number
      manner_type: MANNER_TYPE
    },
    store: any
  ) => {
    const resp = await http.post('/live/activity/cp_invitation_handle', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// -1: 未开启 0: 空闲 1:邀请中  2 已绑定
export enum CP_STATUS {
  unopened = -1,
  available = 0,
  inviting = 1,
  bound = 2,
}
// 领取状态 0：未解锁 1：未领取 2：已领取
export enum TASK_STATUS {
  locked = 0,
  available = 1,
  received = 2,
}
export interface IMember {
  avatar: string
  id: number
  name: string
  zy_id: string
}
export interface IRank {
  rank: number
  score: number
  small_member_info: IMember
  big_member_info: IMember
}
export interface CpTaskItem {
  receive_id: number
  url: string
  desc: string
  status: number
  expire: number
}
export interface CpLetterItem {
  id: number
  target: number
  desc: string
  status: number
}
export interface CpHomeInfo {
  position?: number
  small_member_info: IMember
  big_member_info: IMember
  rank: number
  score: number
  status?: CP_STATUS
  not_open_desc?: string
  task_infos?: Array<CpTaskItem>
  letter_infos?: Array<CpLetterItem>
}

const initialState: {
  rankInfo: {
    list: Array<IRank>
    owners: Array<IRank>
    winners: Array<IMember>
  }
  owners: Array<CpHomeInfo>
} = {
  rankInfo: {
    list: [],
    owners: [],
    winners: [],
  },
  owners: [],
}

export const ShowYourLoveSlice = createSlice({
  name: 'ShowYourLove',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRank.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        state.rankInfo = {
          ...data,
          owners: data.owners.sort((a, b) => b.score - a.score),
        }
      })
      .addCase(cp_home.fulfilled, (state, action) => {
        const {data = {}} = action.payload
        Object.assign(state, data)
      })
  },
})

export default ShowYourLoveSlice.reducer
